import React from 'react'
import { Input } from "./ui/input";
import { Search } from 'lucide-react';

const SearchInput = ({ search, handleSearch }) => {
  return (
    <div className="relative w-64">
      <Search className="absolute left-2 top-3 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Search..."
        value={search}
        onChange={handleSearch}
        className="pl-8"
      />
    </div>
  )
}

export default SearchInput